import { StackProps, VStack } from "@chakra-ui/react";
import * as React from "react";

export interface SidebarSectionProps extends StackProps {
  children?: React.ReactNode;
}

export default function SidebarSection({
  children,
  ...rootProps
}: SidebarSectionProps) {
  return (
    <VStack align="left" p="3" gap="1" {...rootProps}>
      {children}
    </VStack>
  );
}
